import React from "react"
import { usePaths } from "@engaging-tech/routing"

import { libraryPostTypes } from "../../../features/userGeneratedContent/lib/postTypes"

import DetailsLayout from "../../../layouts/DetailsLayout"
import AuthGuard from "../../../features/ui/containers/AuthGuard"
import Publish from "../../../features/businessLibrary/containers/Publish"

const PublishPodcastForm = Publish(libraryPostTypes.podcasts)

const Podcast = () => {
  const paths = usePaths()

  return (
    <AuthGuard>
      <DetailsLayout
        backTo={paths.resourceCentre.browse.podcasts.selectedPodcast}
      >
        <PublishPodcastForm />
      </DetailsLayout>
    </AuthGuard>
  )
}

export default Podcast
